document.addEventListener('DOMContentLoaded', () => {

    const urlParams = new URLSearchParams(window.location.search);
    const redirectFrom = urlParams.get('redirect_from');

    if (redirectFrom == null) {
        return;
    }

    if (redirectFrom.length > 0) {
        const selectedModal = [...document.querySelectorAll('.redirect-modal')].filter(el => {
            return el.getAttribute('data-query') === redirectFrom;
        })[0]

        if (selectedModal) {
            selectedModal.classList.add('redirect-modal--active');
        }
    }

    [...document.querySelectorAll('.redirect-modal')].map(el => {
        el.querySelector('.redirect-modal__close').addEventListener('click', () => {
            el.classList.remove('redirect-modal--active');
        })
        el.querySelector('.link--popup').addEventListener('click', () => {
            el.classList.remove('redirect-modal--active');
        })
    })

    // console.log('URL PARAMS: ', redirectFrom);

});